import * as React from 'react';

import classnames from 'classnames';
import PropTypes from 'prop-types';

import {ChevronLeftIcon, ChevronRightIcon} from '../../icon';

import styles from './scroll-button.module.css';

export class ScrollButton extends React.Component {
    static propTypes = {
        orientation: PropTypes.string.isRequired,
        className: PropTypes.string,
        iconClassName: PropTypes.string,
        onClick: PropTypes.func,
        onMouseEnter: PropTypes.func,
        onMouseLeave: PropTypes.func,
    };

    render() {
        return (
            <button
                onClick={this.props.onClick}
                onMouseEnter={this.props.onMouseEnter}
                onMouseLeave={this.props.onMouseLeave}
                className={classnames(
                    this.props.className,
                    this.props.orientation === 'left'
                        ? styles['button-left']
                        : styles['button-right']
                )}
            >
                {this.props.orientation === 'left' ? (
                    <ChevronLeftIcon className={this.props.iconClassName} />
                ) : (
                    <ChevronRightIcon className={this.props.iconClassName} />
                )}
            </button>
        );
    }
}
